const Plugin = {
  install (Vue, options) {
    /**
     * Registra uma única espera de evento em um único alvo.
     * addEventListener support for IE8
     * @param  {HTMLElement} element      Alvo
     * @param  {String}      eventName    Uma linha de texto que representa o tipo de evento a ser esperado.
     * @param  {Function}    eventHandler O objeto/função que recebe uma notificação quando um evento do tipo especificado ocorre.
     */
    Vue.prototype.$bindEvent = function (element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false)
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler)
      }
    }
  }
}

export default Plugin
